/* Lumann quick add. One delegated listener per event type, no libraries.
   1. Product cards (snippets/lumann-card.liquid): form[data-lm-quickadd], plain form post to the cart when JS is off.
   2. Cart suggestions (snippets/lumann-cart.liquid): button[data-lm-add]. Buttons, not forms, because they sit inside the cart form.
   Adds 1 item via the AJAX cart and asks Motion's cart drawer to refresh and open.
   On the cart page the page reloads; from a product card it falls back to the cart page if the drawer does not open.
   3. Cart count in the header bubble and drawer title, and the total on the checkout button (bottom of this file). */
(function () {
  if (window.lmQuickAdd) return;
  window.lmQuickAdd = true;

  function add(b, id, url, added, cartUrl) {
    if (!b || b.disabled) return;
    var label = b.textContent;
    var onPage = !!b.closest('#CartPageForm');
    b.disabled = true;
    b.setAttribute('aria-busy', 'true');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        if (onPage) { location.reload(); return; }
        var item = j.items && j.items[0];
        ['ajaxProduct:added', 'cart:build', 'cart:open'].forEach(function (n) {
          document.dispatchEvent(new CustomEvent(n, { detail: { product: item } }));
        });
        b.textContent = added || label;
        if (cartUrl) {
          setTimeout(function () {
            if (!document.querySelector('.js-drawer-open,.drawer--is-open')) location.href = cartUrl;
          }, 500);
        }
        setTimeout(function () { b.textContent = label; }, 2000);
      })
      .catch(function (x) {
        b.textContent = (x && (x.description || x.message)) || label;
        setTimeout(function () { b.textContent = label; }, 3000);
      })
      .then(function () {
        b.disabled = false;
        b.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-lm-quickadd]');
    if (!f) return;
    e.preventDefault();
    add(f.querySelector('button'), f.elements.id.value, f.dataset.addUrl, f.dataset.added, f.dataset.cartUrl);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-lm-add]');
    if (!b) return;
    e.preventDefault();
    add(b, b.dataset.lmAdd, b.dataset.addUrl, b.dataset.added, null);
  });

  /* Cart count + checkout total. Motion re-renders [data-products] and [data-discounts] from templates/cart.ajax.liquid
     after every cart change (add, quantity, remove). We read the new count from .cart__items[data-count] and copy it to
     every [data-lm-cart-count]: the header bubble (snippets/header-icons.liquid) and the drawer title. No extra request. */
  if (!window.MutationObserver) return;
  var raf;
  function sync() {
    var items = document.querySelector('[data-products] .cart__items');
    if (items) {
      var n = parseInt(items.getAttribute('data-count'), 10) || 0;
      var label = n > 99 ? '99+' : String(n);
      document.querySelectorAll('[data-lm-cart-count]').forEach(function (el) {
        var isBubble = el.hasAttribute('data-lm-bubble');
        var txt = isBubble && n === 0 ? '' : label;
        if (el.textContent !== txt) el.textContent = txt;
        if (isBubble) el.classList.toggle('cart-link__bubble--visible', n > 0);
      });
    }
    var total = document.querySelector('#CartDrawer [data-lm-total]');
    var btn = document.querySelector('[data-lm-checkout-total]');
    if (total && btn && btn.textContent !== total.textContent) btn.textContent = total.textContent;
  }
  var mo = new MutationObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); });
  document.querySelectorAll('[data-products],[data-discounts]').forEach(function (el) { mo.observe(el, { childList: true }); });
})();
